import { FormattedMessage } from 'react-intl';
import React, { Component } from 'react';
import { getLanguageOptions, getMultiLangEmpty } from './CommonUIComponents';
import moment from 'moment';
import { getAPI } from '../API';
import stripeLogo from '../../../img/Stripelogo.svg';
import shift4Logo from '../../../img/Shift4.png';
import reduniqLogo from '../../../img/logo-reduniq.svg';


const HelpLink = [
    { id: 'manageruserhelp', link: 'https://hostpms.atlassian.net/wiki/spaces/HEYC/pages/1050214439/Gerir+Utilizadores' },
    { id: 'voucherManagementHelp', link: 'https://hostpms.atlassian.net/wiki/spaces/HEYC/pages/1046085665/Cart+o' },
    { id: 'dashboard', link: 'https://hostpms.atlassian.net/wiki/spaces/HEYC/pages/1046216718/Dashboard' },
    { id: 'terms&conditions', link: 'https://hostpms.atlassian.net/wiki/spaces/HEYC/pages/1046642708/Termos+e+Condi+es' },
    { id: 'voucherTemplates', link: 'https://hostpms.atlassian.net/wiki/spaces/HEYC/pages/1050116119/Templates+de+Email' },
    { id: 'voucherIssueAutomation', link: 'https://hostpms.atlassian.net/wiki/spaces/HEYC/pages/1050050616/Emiss+o+Autom+tica' },
    { id: 'referenceData', link: 'https://hostpms.atlassian.net/wiki/spaces/HEYC/pages/1050214456/Dados+de+Refer+ncia' },
    { id: 'promotions', link: 'https://hostpms.atlassian.net/wiki/spaces/HEYC/pages/1911652353/Promo+es' },
    { id: 'logsDashboard', link: 'https://hostpms.atlassian.net/wiki/spaces/HEYC/pages/1050378276/Hist+rico' },
    { id: 'operationManagement', link: 'https://hostpms.atlassian.net/wiki/spaces/HEYC/pages/1050345622/Todos+os+Cart+es' },
    { id: 'shopping', link: 'https://hostpms.atlassian.net/wiki/spaces/HEYC/pages/2625241110/Shopping' },
    { id: 'onlineSales', link: 'https://hostpms.atlassian.net/wiki/spaces/HEYC/pages/1050673272/Vendas+Online' },
    { id: 'reservationVoucher', link: 'https://hostpms.atlassian.net/wiki/spaces/HEYC/pages/1050050681/Cart+o+de+Reservas' },
    { id: 'useVoucher', link: 'https://hostpms.atlassian.net/wiki/spaces/HEYC/pages/1050083447/Utilizar+Cart+o' },
    { id: 'profilesDashboard', link: 'https://hostpms.atlassian.net/wiki/spaces/HEYC/pages/1422098445/Perfis' },
    { id: 'hotelList', link: 'https://hostpms.atlassian.net/wiki/spaces/HEYC/pages/1050050738/Lista+de+Hot+is' },
    { id: 'hotelConfig', link: 'https://hostpms.atlassian.net/wiki/spaces/HEYC/pages/1050247359/Configura+o+do+Hotel' },
    { id: 'pmsConnectivity', link: 'https://hostpms.atlassian.net/wiki/spaces/HEYC/pages/1050280081/Conectividade+PMS' },
    { id: 'paymentManagement', link: 'https://hostpms.atlassian.net/wiki/spaces/HEYC/pages/1045987366/Pagamentos' },
    { id: 'tagsHelp', link: 'https://hostpms.atlassian.net/wiki/spaces/HEYC/pages/2768142363/Tags' },
    { id: 'usageReportHelp', link: 'https://hostpms.atlassian.net/wiki/spaces/HEYC/pages/3401449496/Relat+rio+de+Utiliza+o' }
];

//Notification template types designed on Stripo (mirror of NotificationTemplateType, the Voucher type has its own designer)
export const EMAIL_TEMPLATE_TYPES = ['EmailBody', 'EmailBodyGift', 'OnlineSale'];


export function getVoucherTypes() {
    let opt = [
        { value: true, label: <FormattedMessage id="ReferenceDataFunctions.Payment" /> },
        { value: false, label: <FormattedMessage id="ReferenceDataFunctions.Service" /> }
    ];
    return opt;
}

export function getVoucherValidUntilUnit(intl) {
    let opt = [
        { label: intl.formatMessage({ id: "EditVoucher.Months" }), value: 'Months' },
        { label: intl.formatMessage({ id: "EditVoucher.Days" }), value: 'Days' },
        { label: intl.formatMessage({ id: "EditVoucher.FixedDate" }), value: 'FixedDate' }
    ];
    
    return opt;
}

export const calcValidUntilDate = (validUntilValue, validUntilUnit, validUntilFixedDate) => {
    if (validUntilUnit === 'FixedDate') {
        return validUntilFixedDate ? moment(validUntilFixedDate).endOf('day') : moment().add(1, 'day');
    }
    else {
        const unit = validUntilUnit?.toLowerCase() || 'months';
        
        return moment().add(validUntilValue, unit);
    }
}

export function getStatus(includePaymentModeVoucherStatus = false) {
    // Common states for all voucher types
    let opt = [
        { value: 'created', label: <FormattedMessage id="ReferenceDataFunctions.Created" />, color: 'warning' },
        { value: 'sold', label: <FormattedMessage id="ReferenceDataFunctions.Sold" />, color: 'success' },
        { value: 'redeemed', label: <FormattedMessage id="ReferenceDataFunctions.Redeemed" />, color: 'info' },
        { value: 'partialRedeemed', label: <FormattedMessage id="ReferenceDataFunctions.PartialRedeemed" />, color: 'info' },

        { value: 'cancelled', label: <FormattedMessage id="ReferenceDataFunctions.Canceled" />, color: 'secondary' },
        { value: 'refunded', label: <FormattedMessage id="ReferenceDataFunctions.Refunded" />, color: 'secondary' },
        { value: 'partialRefund', label: <FormattedMessage id="ReferenceDataFunctions.PartialRefund" />, color: 'secondary' }
    ];

    // States only for monetary vouchers
    if (includePaymentModeVoucherStatus) {
        opt.push(
            { value: 'expiredWithInvoice', label: <FormattedMessage id="ReferenceDataFunctions.ExpiredWithInvoice" />, color: 'dark' },
        );
    }

    return opt;

}

// Normalized online payment states, as stored in OnlinePayment.PaymentStatus
export const PAYMENT_STATUS = { PENDING: 'pending', SUCCEEDED: 'succeeded', FAILED: 'failed', CANCELED: 'canceled', UNKNOWN: 'unknown' };

export function getPaymentStatuses() {
    return [
        { value: PAYMENT_STATUS.PENDING, label: <FormattedMessage id="OnlinePaymentStatus.pending" />, color: 'warning' },
        { value: PAYMENT_STATUS.SUCCEEDED, label: <FormattedMessage id="OnlinePaymentStatus.succeeded" />, color: 'success' },
        { value: PAYMENT_STATUS.FAILED, label: <FormattedMessage id="OnlinePaymentStatus.failed" />, color: 'danger' },
        { value: PAYMENT_STATUS.CANCELED, label: <FormattedMessage id="OnlinePaymentStatus.canceled" />, color: 'secondary' },
        { value: PAYMENT_STATUS.UNKNOWN, label: <FormattedMessage id="OnlinePaymentStatus.unknown" />, color: 'dark' }
    ];
}

export const PAYMENT_GATEWAYS = { STRIPE: 'Stripe', SHIFT4: 'Shift4', REDUNIQ: 'Reduniq' };

export function getPaymentGateways() {
    return [
        { value: PAYMENT_GATEWAYS.STRIPE, label: 'Stripe', logo: stripeLogo },
        { value: PAYMENT_GATEWAYS.SHIFT4, label: 'Shift4', logo: shift4Logo },
        { value: PAYMENT_GATEWAYS.REDUNIQ, label: 'Reduniq', logo: reduniqLogo }
    ];
}

export function getPmsStatus() {
    let opt = [
        { value: 0, label: <FormattedMessage id="ReferenceDataFunctions.Created" /> },
        { value: 4, label: <FormattedMessage id="ReferenceDataFunctions.Pending" /> },
        { value: 6, label: <FormattedMessage id="ReferenceDataFunctions.Canceled" /> },
        { value: 7, label: <FormattedMessage id="ReferenceDataFunctions.NoShow" /> },
        { value: 9, label: <FormattedMessage id="ReferenceDataFunctions.Refused" /> },
        { value: 10, label: <FormattedMessage id="ReferenceDataFunctions.CheckIn" />},
        { value: 20, label: <FormattedMessage id="ReferenceDataFunctions.CheckOut" /> }
    ];
    return opt;

}

export function getChannels() {
    const opt = [
        {
            value: 'Frontend',
            label: <FormattedMessage id="ReferenceDataFunctions.Local" />
        },
        {
            value: 'Online',
            label: <FormattedMessage id="ReferenceDataFunctions.Online" />
        },
        /*{
            value: 'Reservation',
            label: <FormattedMessage id="ReferenceDataFunctions.Reservation" />
        }*/
    ];
    return opt;
}

export function getCurrency() {
    let opt = [
        {
            "value": "€",
            "label": "EUR"
        },
        {
            "value": "$",
            "label": "USD"
        },
        {
            "value": "R$",
            "label": "BRL"
        },
        {
            "value": "C$",
            "label": "CAD"
        },
        {
            "value": "£",
            "label": "GBP"
        },
        {
            "value": "Kz",
            "label": "AOA"
        }
    ];
    return opt;

}

export function getRefundReasons(paymentGateway) {
    if (paymentGateway === PAYMENT_GATEWAYS.SHIFT4) {
        return getShift4RefundReasons();
    }
    else 
        return getStripeRefundReasons();
}

function getShift4RefundReasons() {
    let opt = [
        { label: 'Expired', value: 'expired' },
        { label: 'Fraudulent', value: 'fraudulent' }
        
    ];
    return opt;
}

function getStripeRefundReasons() {
    let opt = [
        { label: 'Requested by Customer', value : 'requested_by_customer' },
        { label: 'Duplicate', value: 'duplicate' },
        { label: 'Fraudulent', value: 'fraudulent' }
        
    ];
    return opt;
}


export function getPromoteTypes() {
    let opt = [
        { label: 'Deal of the Week', value: 'dealweek' },
        { label: 'Hot Deal', value: 'hotdeal' }

    ];
    return opt;

}

export function getHelpLink(id) {
    let lnk = HelpLink.find(el => el.id === id);

    if (lnk) return lnk.link
    else return null
}

export function getAutoEmissionType() {
    let opt = [
        { value: 'Room', label: <FormattedMessage id="ReferenceDataFunctions.Room" /> },
        { value: 'Reservation', label: <FormattedMessage id="ReferenceDataFunctions.Reservation" /> },
        { value: 'Guest', label: <FormattedMessage id="ReferenceDataFunctions.Guest" /> }
    ];
    return opt;
}

export function getAutoValidityType() {
    let opt = [
        { value: 'ReservationDates', label: <FormattedMessage id="ReferenceDataFunctions.ReservationDates" /> },
        { value: 'ConfigurationDates', label: <FormattedMessage id="ReferenceDataFunctions.ConfigurationDates" /> }
    ];
    return opt;
}

export function getAutoEmissionScheduleType() {
    let opt = [
        { value: 'BeforeCheckIn', label: <FormattedMessage id="ReferenceDataFunctions.BeforeCheckIn" /> },
        { value: 'AfterCheckOut', label: <FormattedMessage id="ReferenceDataFunctions.AfterCheckOut" /> }
    ];
    return opt;
} 

export function getConnectionType() {
    let opt = [
        { value: 'PmsReservations', label: <FormattedMessage id="ReferenceDataFunctions.PmsReservations" /> }
    ];
    return opt;
}

export function getFonts() {
    const fonts = [
        {
            value: 'Agency FB',
            label: 'Agency FB'
        },
        {
            value: 'Albertina',
            label: 'Albertina'
        },
        {
            value: 'Antiqua',
            label: 'Antiqua'
        },
        {
            value: 'Architect',
            label: 'Architect'
        },
        {
            value: 'Arial',
            label: 'Arial'
        },
        {
            value: 'BankFuturistic',
            label: 'BankFuturistic'
        },
        {
            value: 'BankGothic',
            label: 'BankGothic'
        },
        {
            value: 'Blackletter',
            label: 'Blackletter'
        },
        {
            value: 'Blagovest',
            label: 'Blagovest'
        },
        {
            value: 'Calibri',
            label: 'Calibri'
        },
        {
            value: 'Comic Sans MS',
            label: 'Comic Sans MS'
        },
        {
            value: 'Consolas',
            label: 'Consolas'
        },
        {
            value: 'Courier',
            label: 'Courier'
        },
        {
            value: 'Cursive',
            label: 'Cursive'
        },
        {
            value: 'Decorative',
            label: 'Decorative'
        },
        {
            value: 'Fantasy',
            label: 'Fantasy'
        },
        {
            value: 'Fraktur',
            label: 'Fraktur'
        },
        {
            value: 'Frosty',
            label: 'Frosty'
        },
        {
            value: 'Garamond',
            label: 'Garamond'
        },
        {
            value: 'Georgia',
            label: 'Georgia'
        },
        {
            value: 'Helvetica',
            label: 'Helvetica'
        },
        {
            value: 'Impact',
            label: 'Impact'
        },
        {
            value: 'Minion',
            label: 'Minion'
        },
        {
            value: 'Modern',
            label: 'Modern'
        }, 
        {
            value: 'Monospace',
            label: 'Monospace'
        },
        {
            value: 'Montserrat',
            label: 'Montserrat'
        },
        {
            value: 'Open Sans',
            label: 'Open Sans'
        },
        {
            value: 'Palatino',
            label: 'Palatino'
        },
        {
            value: 'Perpetua',
            label: 'Perpetua'
        },
        {
            value: 'Roman',
            label: 'Roman'
        },
        {
            value: 'Sans-serif',
            label: 'Sans-serif'
        },
        {
            value: 'Serif',
            label: 'Serif'
        },
        {
            value: 'Script',
            label: 'Script'
        },
        {
            value: 'Swiss',
            label: 'Swiss'
        },
        {
            value: 'Tahoma',
            label: 'Tahoma'
        },
        {
            value: 'Times',
            label: 'Times'
        },
        {
            value: 'Times New Roman',
            label: 'Times New Roman'
        },
        {
            value: 'Tw Cen MT',
            label: 'Tw Cen MT'
        },
        {
            value: 'Verdana',
            label: 'Verdana'
        }
    ];
    return fonts;
}

export function getLicenseModules() {
    let opt = [
        { value: 'PMSIntegration', label: <FormattedMessage id="ReferenceDataFunctions.PMSIntegration" /> }
    ];
    return opt;
} 

export function getPaymentType() {
    let opt = [
        //{ value: 'Prepay', label: <FormattedMessage id="ReferenceDataFunctions.Prepay" /> },
        //{ value: 'Postpaid', label: <FormattedMessage id="ReferenceDataFunctions.Postpaid" /> },
        { value: 'Monthlyfee', label: <FormattedMessage id="ReferenceDataFunctions.Monthlyfee" /> }
    ];
    return opt;
}

export function getTaxCodes() {
    let opt = [
        { value: 'RED', label: < FormattedMessage id="ReferenceDataFunctions.VATReduced" /> },
        { value: 'INT', label: < FormattedMessage id="ReferenceDataFunctions.VATIntermediate" /> },
        { value: 'NOR', label: < FormattedMessage id="ReferenceDataFunctions.VATNormal" /> },
        { value: 'ISE', label: < FormattedMessage id="ReferenceDataFunctions.VATExempt" /> }
    ];
    return opt;
}

export function processMultilingualTexts(item) {
    const multiLangArray = getMultiLangEmpty();
    if (item.multiLingual.length === 0) {
        item.multiLingual = multiLangArray;
    }
    else if (item.multiLingual.length !== multiLangArray.length) {
        multiLangArray.forEach(multiLang => {
            const language = item.multiLingual.find(ml => ml.languageCode === multiLang.languageCode);
            if (!language) {
                item.multiLingual.push(multiLang);
            }
            else {
                language.language = multiLang.language
            }
        });
    }
    else {
        item.multiLingual.forEach(multiLingual => {
            const lang = multiLangArray.find(ml => ml.languageCode === multiLingual.languageCode);
            if (lang) {
                multiLingual.language = lang.language
            }
        });
    }
}

export function getHotelGroupModules(intl) {
    const opt = [
        { value: 'PNIntegration', label: intl.formatMessage({ id: "ReferenceDataFunctions.PNIntegration" }) },
        { value: 'ShortId', label: intl.formatMessage({ id: "ReferenceDataFunctions.ShortId" }) },
        { value: 'SendGrid', label: "SendGrid" },
        { value: 'InvoiceAction', label: intl.formatMessage({ id: "ReferenceDataFunctions.InvoiceAction" }) },
        { value: 'VoucherPIN', label: "Voucher PIN" },
        { value: 'VoucherRFID', label: "Voucher RF ID" },
        { value: 'Complex', label: intl.formatMessage({ id: "ReferenceDataFunctions.Complex" }) },
        { value: 'CancellationReason', label: intl.formatMessage({ id: "ReferenceDataFunctions.CancellationReason" }) },
        { value: 'RebateAction', label: intl.formatMessage({ id: "ReferenceDataFunctions.RebateAction" }) },     
        { value: 'StripoSharedAccount', label: "Stripo Shared Account" },
        { value: 'GoogleWallet', label: "Google Wallet" },
        { value: 'AppleWallet', label: "Apple Wallet" },
        { value: 'EmailDesigner', label: intl.formatMessage({ id: "ReferenceDataFunctions.EmailDesigner" }) },
        { value: 'AiFeatures', label: intl.formatMessage({ id: "ReferenceDataFunctions.AiFeatures" }) },
        { value: 'VoucherDesigner', label: intl.formatMessage({ id: "ReferenceDataFunctions.VoucherDesigner" }) }
    ];
    return opt;
}

export function getCodeGenerationTypes(intl) {
    const opt = [
        { value: 'BarCode', label: intl.formatMessage({ id: "ReferenceDataFunctions.BarCode" }) },
        { value: 'QrCode', label: intl.formatMessage({ id: "ReferenceDataFunctions.QrCode" }) }
    ];
    return opt;
}

export function getRebateActions(intl) {
    const opt = [
        { value: 'Discount', label: intl.formatMessage({ id: "ReferenceDataFunctions.Discount" }) },
        { value: 'Bill', label: intl.formatMessage({ id: "ReferenceDataFunctions.Bill" }) }
    ];
    return opt;
}

export function getRightVoucherId(voucherGuid, shortVoucherId) {
    return global.shortId ? shortVoucherId : voucherGuid
}


export function getWidgetLanguages(intl) {
    return [
        { value: 'pt', label: intl.formatMessage({ id: "MultiLang.Portuguese" }) },
        { value: 'en', label: intl.formatMessage({ id: "MultiLang.English" }) }
    ];
}

export function getLanguages() {
    return [
        { value: 'en-GB', label: <FormattedMessage id="generic.en-GB" /> },
        { value: 'pt-PT', label: <FormattedMessage id="generic.pt-PT" /> },
        { value: 'fr-FR', label: <FormattedMessage id="generic.fr-FR" /> },
        { value: 'es-ES', label: <FormattedMessage id="generic.es-ES" /> },
        { value: 'de-DE', label: <FormattedMessage id="generic.de-DE" /> },
        { value: 'it-IT', label: <FormattedMessage id="generic.it-IT" /> },
        { value: 'pl-PL', label: <FormattedMessage id="generic.pl-PL" /> }
    ];
}

export function getHotelLanguageCode() {
    const hotelCultureCode = global.defaultCultureCode;
    const voucherLangList = getLanguageOptions();
    
    let hotelLang = hotelCultureCode && typeof hotelCultureCode === 'string' ? hotelCultureCode.substring(0, 2).toUpperCase() : null;

    if (hotelLang && voucherLangList.some(lang => lang.value === hotelLang)) {
        return hotelLang;
    }

    return voucherLangList[0].value;
}

// Translation to show for a multiLingual list: preferred language (optional), then hotel language, then EN, then the first language with text.
// field is the property that must have text; without it, title or description.
export function getTranslation(multiLingual, field, lang) {
    if (!Array.isArray(multiLingual)) return null;

    const hasText = (ml) => field ? ml[field] : (ml.title || ml.description);
    const findByLang = (code) => code && multiLingual.find(ml => ml.languageCode?.toUpperCase() === code.toUpperCase() && hasText(ml));

    return findByLang(lang)
        || findByLang(getHotelLanguageCode())
        || findByLang('EN')
        || multiLingual.find(hasText)
        || null;
}

// Label of a voucher tag in selects: translated code, then the base code
export function getVoucherTagLabel(tag) {
    return getTranslation(tag.multiLingual, 'code')?.code || tag.code;
}

export function getColorPalette() {
    return ['#00bc71', '#64dd17', '#00a5ab', '#008ec7', '#0076d2', '#00ce57']
}

export function getMonetaryVoucherActions(intl) {
    return [
        { value: 'Payment', label: intl.formatMessage({ id: "ReferenceDataFunctions.PaymentAction" }) },
        { value: 'Invoice', label: intl.formatMessage({ id: "ReferenceDataFunctions.Invoice" }) }
    ];
}

export const PAYMENT_METHODS = { CREDIT_CARD: 'CreditCard', MB_WAY: 'MbWay', MULTIBANCO: 'Multibanco' };

// Methods each gateway can offer in the widget: only Reduniq has MB WAY and Multibanco
export function getValidPaymentMethods(gateway) {
    const methods = [
        {
            value: PAYMENT_METHODS.CREDIT_CARD,
            label: <FormattedMessage id="Payments.CreditCard" />,
            img: (size, color) => <i className={`fa-solid fa-credit-card ${color}`} style={{ fontSize: `${size}px` }} />
        },
        {
            value: PAYMENT_METHODS.MB_WAY,
            label: <FormattedMessage id="Payments.MbWay" />,
            img: (size, color) => <i className={`fa-solid fa-mobile-screen ${color}`} style={{ fontSize: `${size}px` }} />
        },
        {
            value: PAYMENT_METHODS.MULTIBANCO,
            label: <FormattedMessage id="Payments.Multibanco" />,
            img: (size, color) => <i className={`fa-solid fa-building-columns ${color}`} style={{ fontSize: `${size}px` }} />
        }
    ];

    return gateway === PAYMENT_GATEWAYS.REDUNIQ ? methods : methods.filter(m => m.value === PAYMENT_METHODS.CREDIT_CARD);
}

/* #region Profile Creation Config */
export const profileCreationDefaultConfig = [
    { key: 'firstName',      labelId: 'ProfileDetail.FirstName',    alwaysRequired: false },
    { key: 'lastName',       labelId: 'ProfileDetail.LastName',     alwaysRequired: true,  noteId: 'ProfileCreationConfig.RequiredNote' },
    { key: 'email',          labelId: 'ProfileDetail.Email',        alwaysRequired: true,  noteId: 'ProfileCreationConfig.RequiredNote' },
    { key: 'fiscalNumber',   labelId: 'ProfileDetail.FiscalNumber', alwaysRequired: true,  noteId: 'ProfileCreationConfig.RequiredNote' },
    { key: 'phone',          labelId: 'ProfileDetail.Phone',        alwaysRequired: false },
    { key: 'postCode',       labelId: 'ProfileDetail.PostCode',     alwaysRequired: false },
    { key: 'city',           labelId: 'ProfileDetail.City',         alwaysRequired: false },
    { key: 'address',        labelId: 'ProfileDetail.Address',      alwaysRequired: false },
    { key: 'countryCode',    labelId: 'ProfileDetail.Country',      alwaysRequired: false, noRegex: true },
];

export function getProfileCreationConfig(callback) {
    getAPI(result => {
        const { data, error } = result;
        if (error) {
            callback({ error });
            return;
        }
        if (data) {
            const fieldsConfig = profileCreationDefaultConfig.map(f => {
                const saved = data.response && data.response.find(x => x.fieldKey === f.key);

                return saved
                    ? { id: saved.id, fieldKey: saved.fieldKey, isRequired: f.alwaysRequired ? true : saved.isRequired, regex: saved.regex || '' }
                    : { id: 0, fieldKey: f.key, isRequired: f.alwaysRequired, regex: '' };
            });

            callback({ data, fieldsConfig });
        }
    }, '/api/Voucher/Profile/v1/ProfileCreationConfig');
}
/* #endregion */
